<template>
	<div style="border-top: 0.01rem solid #f1f1f1; padding-bottom: 1rem;"></div>
</template>

<script>
export default {
	name: "lineComp"
}
</script>

<style scoped>

</style>